module.exports = __webpack_public_path__ + "img/1.1de7d922.png";